<template>
  <div class="row">
    <div class="col">
      <div class="row">
        <div class="col-4 lbl">
          <label>Entité :</label>
        </div>
        <div class="col">
          <Dropdown class="dropdown-height"
                    v-model="entite"
                    :options="entiteLibelles"
                    optionValue="valeur"
                    optionLabel="texte"
                    scrollHeight="205px"
                    :showClear="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Genre :</label>
        </div>
        <div class="col">
          <Dropdown class="dropdown-height"
                    v-model="genre"
                    :options="genreLibelles"
                    optionValue="valeur"
                    optionLabel="texte"
                    scrollHeight="205px"
                    :showClear="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Nature :</label>
        </div>
        <div class="col">
          <Dropdown v-model="nature"
                    :options="natureLibelles"
                    optionValue="valeur"
                    optionLabel="texte"
                    scrollHeight="205px"
                    :showClear="true"/>
        </div>
      </div>
      <div class="row">
        <div class="col-4 lbl">
          <label>Type :</label>
        </div>
        <div class="col">
          <Dropdown v-model="type"
                    :options="typeLibelles"
                    optionValue="valeur"
                    optionLabel="texte"
                    @:keyup.enter="rechercher"
                    scrollHeight="205px"
                    :showClear="true"/>
        </div>
      </div>
    </div>
    <div class="col border-white">
      <div class="row">
        <div class="col"></div>
      </div>
      <div class="row">
        <div class="col">
          <Button label="Gestion genre" v-on:click="gestionGenre"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button label="Gestion nature" v-on:click="gestionNature"/>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Button label="Gestion type" v-on:click="gestionType"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <Button @click="rechercher"> Rechercher </Button>
    </div>
    <div class="col" >
      <Button @click="effacerCriteres"> Effacer critères </Button>
    </div>
    <div class="col" >
      <Button @click="imprimer"> Imprimer </Button>
    </div>
    <div class="col" >
      <Button @click="ajouterCategorie"> Ajouter </Button>
    </div>
    <div class="col">
      <Button @click="fermer"> Fermer </Button>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import axios from "axios";

export default {
  name: "CriteresRechercheCategorie",
  emits: ['rechercher', 'fermer'],
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  data() {
    return {
      entite: null,
      genre: null,
      nature: null,
      type: null,
      entiteLibelles: [],
      genreLibelles: [],
      natureLibelles: [],
      typeLibelles: [],
    }
  },
    mounted() {
      axios.defaults.headers.common['cleProfil'] = this.profil.cle;
      this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
        .then((res) => {
            this.assignerListe(res.data.entiteDecision);
        });
      this.$store.dispatch("dossier/obtenirSiteEntiteAction").then((res) => {
        this.entite = res.data.entite;
      });
    },
    methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
    },
    gestionGenre() {
      this.$router.push({name: "rechercherGenre", params: {entite: this.entite}});
    },
    gestionNature() {
      this.$router.push({name: "rechercherNature", params: {entite: this.entite, genre: this.genre}});
    },
    gestionType() {
        this.$router.push({name: "rechercherType", params: {entite: this.entite, genre: this.genre, nature: this.nature}});
    },
    rechercher() {
      let libelleRecherche = {};
      libelleRecherche.valeur = this.entite;
      libelleRecherche.enfant = {};
      libelleRecherche.enfant.valeur = this.genre;
      libelleRecherche.enfant.enfant = {};
      libelleRecherche.enfant.enfant.valeur = this.nature;
      libelleRecherche.enfant.enfant.enfant = {};
      libelleRecherche.enfant.enfant.enfant.valeur = this.type;
      libelleRecherche.enfant.enfant.enfant.enfant = {};
      libelleRecherche.enfant.enfant.enfant.enfant.code = 'Categorie';
      this.$emit('rechercher', libelleRecherche);
    },
    effacerCriteres() {
      this.genre = null;
      this.nature = null;
      this.type = null;
      this.entite = null;
    },
      imprimer() {
        let genreDesc, natureDesc, typeDesc;
        let entite = this.entiteLibelles.filter(l => l.valeur == this.entite);
        let genre = this.genreLibelles.filter(l => l.valeur == this.genre);
        let nature = this.natureLibelles.filter(l => l.valeur == this.nature);
        let type = this.typeLibelles.filter(l => l.valeur == this.type);
        if (genre.length > 0 && genre !== undefined) {
          genreDesc = genre[0].texte;
        }
        if (nature.length > 0 && nature !== undefined) {
          natureDesc = nature[0].texte;
        }
        if (type.length > 0 && type !== undefined) {
          typeDesc = type[0].texte;
        }
        this.$router.push({
          name: 'imprimerClassementDossier',
          params: {entite: this.entite, entiteDesc: entite[0].texte,
            genre: this.genre, genreDesc: genreDesc,
            nature: this.nature, natureDesc: natureDesc,
            type: this.type, typeDesc: typeDesc}
        });
      },
    ajouterCategorie() {
      this.$router.push({name: "ajouterCategorie"});
    },
    fermer() {
      this.$emit('fermer');
    }
  },
  watch: {
    entite: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Genre',
          nouvelleValeur: val
        }).then((res) => {
          this.genreLibelles = res.data;
        });
      } else {
        this.genre = null;
        this.genreLibelles = [];
      }
    },
    genre: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Nature',
          nouvelleValeur: val
        }).then((res) => {
          this.natureLibelles = res.data;
        });
      } else {
        this.nature = null;
        this.natureLibelles = [];
      }
    },
    nature: function (val) {
      if (val !== null && val !== undefined) {
        this.$store.dispatch('dossier/obtenirDecisionLibelleVOsDeCriteresAction', {
          libelleChange: 'Type',
          nouvelleValeur: val
        }).then((res) => {
          this.typeLibelles = res.data;
        });
      } else {
        this.type = null;
        this.typeLibelles = [];
      }
    },
  }
}
</script>
